<template>
<div>
  <div class="flex justify-between">
    <h1 class="mb-8 font-bold text-3xl">Special Offers</h1>
  </div>
  <div class="mb-6 flex justify-between items-center">
    <search-filter v-model="form.search" class="flex-grow mr-4" @reset="reset">
      <div>
        <label class="block text-gray-700">Status:</label>
        <select v-model="form.active" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>
      <div class="mt-4">
        <label class="block text-gray-700">Type:</label>
        <select v-model="form.type" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="global">Global</option>
        </select>
      </div>

    </search-filter>
    <inertia-link class="btn-primary" :href="route('manage.offers.create')">
      <span>Create</span>
      <span class="hidden md:inline">Special Offer</span>
    </inertia-link>
  </div>

  <div class="bg-white rounded shadow overflow-x-auto">
    <table class="w-full whitespace-nowrap">
      <tr class="text-left font-bold">
        <th class="px-6 pt-6 pb-4">ID</th>
        <th class="px-6 pt-6 pb-4">Title</th>
        <th class="px-6 pt-6 pb-4">Priority</th>
        <th class="px-6 pt-6 pb-4">Start Date</th>
        <th class="px-6 pt-6 pb-4">End Date</th>
        <th class="px-6 pt-6 pb-4">Price Group</th>
        <th class="px-6 pt-6 pb-4">Status</th>
        <th class="px-6 pt-6 pb-4">Updated</th>
        <th class="px-6 pt-6 pb-4"></th>
      </tr>
      <tr v-for="offer in offers.data" :key="offer.id" class="hover:bg-gray-100 focus-within:bg-gray-100">

        <td class="border-t text-sm">
          <inertia-link class="px-6 py-4 flex items-center" :href="route('manage.offers.edit', offer.id)" tabindex="-1">
            {{ offer.id }}
          </inertia-link>
        </td>
        <td class="border-t text-sm">
          <inertia-link class="px-6 py-4 flex items-center" :href="route('manage.offers.edit', offer.id)" tabindex="-1">
            {{ offer.title }}
          </inertia-link>
        </td>
        <td class="border-t text-sm">
          <inertia-link class="px-6 py-4 flex items-center" :href="route('manage.offers.edit', offer.id)" tabindex="-1">
            {{ offer.priority }}
          </inertia-link>
        </td>
        <td class="border-t text-sm">
          <inertia-link class="px-6 py-4 flex items-center" :href="route('manage.offers.edit', offer.id)" tabindex="-1">
            {{ offer.start_date | localDate }}
          </inertia-link>
        </td>
        <td class="border-t text-sm">
          <inertia-link class="px-6 py-4 flex items-center" :href="route('manage.offers.edit', offer.id)" tabindex="-1">
            {{ offer.end_date | localDate }}
          </inertia-link>
        </td>
        <td class="border-t text-sm">
          <inertia-link class="px-6 py-4 flex items-center" :href="route('manage.offers.edit', offer.id)" tabindex="-1">
            <span v-if="offer.price_group === 'wholesale'">Wholesale</span>
            <span v-else-if="offer.price_group === 'retail'">Retail</span>
            <span v-else>Other</span>
          </inertia-link>
        </td>
        <td class="border-t text-sm">
          <inertia-link class="px-6 py-4 flex items-center" :href="route('manage.offers.edit', offer.id)" tabindex="-1">
            <span v-if="offer.active" class="text-green-700">Active</span>
            <span v-else class="text-red-800">Inactive</span>
          </inertia-link>
        </td>
        <td class="border-t text-sm">
          <inertia-link class="px-6 py-4 flex items-center" :href="route('manage.offers.edit', offer.id)" tabindex="-1">
            <span>{{ offer.updated_at | localDateTime }}</span>
          </inertia-link>
        </td>
        <td class="border-t w-px">
          <inertia-link class="px-4 flex items-center" :href="route('manage.offers.edit', offer.id)"  tabindex="-1">
            <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
          </inertia-link>
        </td>
      </tr>
      <tr v-if="offers.data.length === 0">
        <td class="border-t px-6 py-4" colspan="9">No offers found.</td>
      </tr>
    </table>

  </div>
  <pagination :links="offers.links" />
</div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Admin/Layout'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import pickBy from 'lodash/pickBy'
import SearchFilter from '@/Shared/SearchFilter'
import throttle from 'lodash/throttle'

export default {
  metaInfo: { title: 'Special Offers' },
  layout: Layout,
  components: {
    Icon,
    Pagination,
    SearchFilter,
  },
  props: {
    offers: Object,
    filters: Object,
  },
  data() {
    return {
      selected: [],
      checkedAll: false,
      form: {
        search: this.filters.search,
        active: this.filters.active,
        type: this.filters.type,
      },
    }
  },
  watch: {
    form: {
      handler: throttle(function() {
        let query = pickBy(this.form)
        this.$inertia.get(this.route('manage.offers', Object.keys(query).length ? query : { remember: 'forget'}), {}, { preserveState: true })
      }, 4000),
      deep: true,
    }
  },

  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },

  }
}
</script>

<style scoped>

</style>
